import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';

const ScreenSizeContext = createContext(null);

const MOBILE_WIDTH_BREAKPOINT = 651;
const TABLET_WIDTH_BREAKPOINT = 992;

const ScreenSizeInfoProvider = ({ children, staticContext = {} }) => {
  const [dimensions, setDimensions] = useState(() => {
    if (typeof window === 'undefined') {
      return {};
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  });
  const [isMobile, setIsMobile] = useState(
    dimensions.width <= MOBILE_WIDTH_BREAKPOINT
  );
  const [isTablet, setIsTablet] = useState(
    dimensions.width > MOBILE_WIDTH_BREAKPOINT &&
      dimensions.width <= TABLET_WIDTH_BREAKPOINT
  );
  const [isDesktop, setIsDesktop] = useState(
    dimensions.width > TABLET_WIDTH_BREAKPOINT
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return () => {};
    }

    const handleResize = throttle(() => {
      let width = window.innerWidth;
      let height = window.innerHeight;

      setDimensions({
        width,
        height
      });

      if (width > TABLET_WIDTH_BREAKPOINT) {
        setIsMobile(false);
        setIsTablet(false);
        setIsDesktop(true);
      } else if (width > MOBILE_WIDTH_BREAKPOINT) {
        setIsMobile(false);
        setIsTablet(true);
        setIsDesktop(false);
      } else {
        setIsMobile(true);
        setIsTablet(false);
        setIsDesktop(false);
      }
    }, 200);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let context;
  if (staticContext.req) {
    const {
      deviceInfo: { isMobile, isTablet, isDesktop } = {}
    } = staticContext.req;
    // this info is set via user agent headers. not fail safe :/
    context = {
      isMobile,
      isTablet,
      isDesktop,
      dimensions
    };
  } else {
    context = {
      dimensions,
      isMobile,
      isTablet,
      isDesktop
    };
  }

  return (
    <ScreenSizeContext.Provider value={context}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

ScreenSizeInfoProvider.propTypes = {
  children: PropTypes.any,
  staticContext: PropTypes.object
};

export default ScreenSizeInfoProvider;
export const useScreenSizeInfo = () => useContext(ScreenSizeContext);
